import { Box, Tab, Tabs } from '@mui/material';
import { useFormContext } from '@/store/usePickemForm.context';
import { usePickemStore } from '@/store/usePickem.store';

interface MainTabsProps {
  value: number;
  onChange: (event: React.SyntheticEvent, newValue: number) => void;
}

function a11yProps(index: number) {
  return {
    id: `settings-tab-${index}`,
    'aria-controls': `settings-tabpanel-${index}`,
  };
}

export const MainTabs = ({ value, onChange }: MainTabsProps) => {
  const defaultTabs = [
    'General Settings',
    'Questions',
    'Prizing',
    'Leaderboard',
    'Rules',
  ];

  const { isPrivateCompetition } = usePickemStore();

  const form = useFormContext();

  const tabs = isPrivateCompetition
    ? [...defaultTabs, 'Participants']
    : defaultTabs;

  return (
    <form.Subscribe selector={(state) => state.values}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          value={value}
          onChange={onChange}
          aria-label='basic tabs example'
          variant='scrollable'
          scrollButtons='auto'
        >
          {tabs.map((tab, index) => (
            <Tab key={tab} label={tab} {...a11yProps(index)} />
          ))}
        </Tabs>
      </Box>
    </form.Subscribe>
  );
};
